import React, { memo, useEffect, useRef } from 'react';
import { Shape } from '../../types/Shape';
import HTMLShapeBase from './HTMLShapeBase';
import hljs from 'highlight.js';
import 'highlight.js/styles/vs2015.css';

interface HTMLCodeBlockProps {
  shape: Shape;
  isSelected: boolean;
  showResizeHandles?: boolean;
  stagePos: { x: number; y: number };
  stageScale: number;
  isDrawing?: boolean;
  isEditing?: boolean;
  currentTool?: string;
  onDragStart?: (shapeId: string) => void;
  onDragMove?: (shapeId: string, newX: number, newY: number) => void;
  onDragEnd?: (shapeId: string) => void;
  onResize?: (shapeId: string, newWidth: number, newHeight: number, newX?: number, newY?: number) => void;
  onResizeEnd?: () => void;
  onClick?: (shapeId: string, e: React.MouseEvent) => void;
  onDoubleClick?: (shapeId: string, e: React.MouseEvent) => void;
  onContextMenu?: (shapeId: string, e: React.MouseEvent) => void;
  onMouseEnter?: (shapeId: string) => void;
  onMouseLeave?: () => void;
  onStageClick?: (canvasX: number, canvasY: number, e: React.MouseEvent) => void;
}

const HTMLCodeBlock: React.FC<HTMLCodeBlockProps> = (props) => {
  const { shape, isEditing = false, stageScale } = props;
  const codeRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (codeRef.current && !isEditing) {
      hljs.highlightElement(codeRef.current);
    }
  }, [shape.code, shape.language, isEditing]);

  return (
    <HTMLShapeBase {...props}>
      <div
        style={{
          width: '100%',
          height: '100%',
          backgroundColor: isEditing ? (shape.fill || '#FFFFFF') : (shape.fill || '#1E1E1E'),
          border: `${(shape.strokeWidth || 2) * stageScale}px solid ${shape.stroke || '#3B82F6'}`,
          borderRadius: `${8 * stageScale}px`,
          boxSizing: 'border-box',
          overflow: 'auto',
          padding: `${6 * stageScale}px`,
          pointerEvents: 'none',
        }}
      >
        {!isEditing && (
          <pre style={{ margin: 0, fontSize: `${(shape.fontSize || 14) * stageScale}px`, lineHeight: '1.5' }}>
            <code
              ref={codeRef}
              className={`language-${shape.language || 'javascript'}`}
              style={{
                fontFamily: '"Fira Code", "Consolas", "Monaco", monospace',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
              }}
            >
              {shape.code || '// 코드를 입력하세요'}
            </code>
          </pre>
        )}
      </div>
    </HTMLShapeBase>
  );
};

export default memo(HTMLCodeBlock);

